export default "__VITE_ASSET__BnNMNWKE__"